// extracted by mini-css-extract-plugin
export default {"wrapper":"PageControls_wrapper__GY-sB","innerWrapper":"PageControls_innerWrapper__zITrr","pageControlsRow":"PageControls_pageControlsRow__Ri4eU"};